import React, {useCallback, useEffect} from "react";
import styled from "styled-components";
import {Grid} from "@material-ui/core";
import youStake from '../../../assets/imgs/you_stake.svg'
import {ButtonWidget} from "../../../widget/pub/button_widget";
import {useHistory} from "react-router-dom";
import {CardInterface} from "../../../interface/personal/card";
import {useModel} from "../../../hook/use_model";
import {DepositModal} from "./deposit_modal";
import {useCapitaStakeDeposit} from "../../../web3/use_fn/capita_stake";
import BigNumber from "bignumber.js";
import {useWait} from "../../../utils/wait_fn";
import {HttpServer} from "../../../net/http_server";
import {useSignFn} from "../../../utils/sign_fn";
import {addArbiterJson} from "../fn/get_sign";
import {InputModel} from "./input_model";
import P1 from "../../../assets/imgs/p1.png"
import P2 from "../../../assets/imgs/p2.png"
import P3 from "../../../assets/imgs/p3.png"
import P4 from "../../../assets/imgs/p4.png"
import {getBalanceNumber} from "../../../utils/formatBalance";
import {useRewards} from "../fn/use_rewards";
import {NSURE, TokenInterFace} from "../../../web3/token.config";
import {useWeb3} from "../../../provider/web3_provider";
import {IsApprove} from "../../../widget/pub/approve_button";

export const TopWapWidget: React.FC = () => {

    const {data, request, setData} = useWait<any>(HttpServer.arbiter);
    const sign = useSignFn();
    const {listToken, tokenMap, contrcts} = useWeb3();
    const tokenCon: TokenInterFace = tokenMap[NSURE];

    const addArbiterFn = useCallback(async (method: string, fn: any, ev: string) => {
        let _params = addArbiterJson(method, ev);
        let _hex = await sign(_params);
        let _login = await fn(_hex, _params);
        setData(_login);
    }, [setData]);

    const rewardsFn = useRewards()


    const [onPending] = useModel(<InputModel
        title={"Deduct Role"}
        buttonTest={'Deduct'}
        callBack={(ev: string) => addArbiterFn('pending', HttpServer.pending, ev)}/>)

    const [onDddArbiter] = useModel(<InputModel
        title={"Add Role"}
        buttonTest={'Add'}
        callBack={(ev: string) => addArbiterFn('add_arbiter', HttpServer.addArbiter, ev)}/>)


    const [handleStake] = useCapitaStakeDeposit();

    const [handlePresent] = useModel(<DepositModal biggest={listToken[NSURE]}
                                                   buttonText={"Deposit"}
                                                   confirmationFn={async (ev: BigNumber) => {
                                                       return await handleStake(ev);
                                                   }}/>);

    const [onRewards] = useModel(<DepositModal
        biggest={new BigNumber(data?.available || 0)}
        buttonText={"Withdraw"}
        confirmationFn={async (ev: string) => {
            return await rewardsFn(ev, 0);
        }}
    />)
    const [onClaim] = useModel(<DepositModal
        buttonText={"Claim"}
        unit={"ETH"}
        biggest={new BigNumber(data?.my_reward || 0)}
        confirmationFn={async (ev: string) => {
            return await rewardsFn(ev, 1);
        }}
    />)


    useEffect(() => {

        request();
        const interval = setInterval(async () => {
            request();
        }, 20000);
        return () => clearInterval(interval)

    }, [])

    return (
        <Grid container spacing={3}>
            {/*<CardWidget*/}
            {/*    title={'Global'}*/}
            {/*    oneTitle={"Total Deposits"}*/}
            {/*    therrTitle={"Total Rewards"}*/}
            {/*    oneUnit={"Nsure"}*/}
            {/*    therrUnit={"ETH"}*/}
            {/*    img={P1}*/}
            {/*/>*/}
            <CardWidget
                title={'Overview'}
                oneTitle={"Nsure Available"}
                oneUnit={"Nsure"}
                oneValue={getBalanceNumber(data?.available).toString()}
                img={P2}
                therrTitle={"Nsure Locked"}
                therrValue={getBalanceNumber(data?.locked).toString()}
            >
                <IsApprove erc20={tokenCon.contract}
                           erc20Address={tokenCon.useAddr}
                           spender={contrcts.stakeAddress}>
                    <Buttons>
                        <ButtonWidget size={{x: 8, y: 25}} onClick={handlePresent} text={'Deposit'}
                                      bgColor={'#584CCC'}/>
                        <ButtonWidget size={{x: 8, y: 25}} onClick={onRewards} text={'Withdraw'} bgColor={'#584CCC'}/>
                    </Buttons>

                </IsApprove>
            </CardWidget>
            <CardWidget
                img={P3}
                title={'Assessor Status'}
                oneTitle={"Pending cases"}
                therrTitle={"Available application roles"}
                oneValue={data?.pending}
                therrValue={data?.available_role}
            >
                <ButtonWidget size={{x: 8, y: 15}} onClick={onDddArbiter} text={'Add role'} bgColor={'#584CCC'}/>
                <ButtonWidget size={{x: 8, y: 15}} onClick={onPending} text={'Deduct role'} bgColor={'#584CCC'}/>
            </CardWidget>
            <CardWidget
                title={'My rewards'}
                img={P4}
                oneTitle={"Rewards Earned"}
                oneValue={getBalanceNumber(data?.reward).toString()}
                oneUnit={"ETH"}
                therrTitle={'ETH Available'}
                therrUnit={'ETH'}
                therrValue={getBalanceNumber(data?.available_eth).toString()}
            >
                <ButtonWidget size={{x: 8, y: 30}}
                              text={'Claim'}
                              onClick={onClaim}
                              bgColor={'#584CCC'}
                />
            </CardWidget>
        </Grid>
    );
}


const CardWidget: React.FC<CardInterface> = ({
                                                 title,
                                                 oneTitle,
                                                 therrTitle,
                                                 oneUnit,
                                                 therrUnit,
                                                 oneValue,
                                                 therrValue,
                                                 img,
                                                 children
                                             }) => {
    return (
        <CardStyle item md={4} sm={4} xs={12}>
            <div>
                <div className={'padding title'}>

                    <img src={img} alt=""/>
                    <span>{title}</span>
                </div>
                <div className={'padding body'}>
                    <div>
                        <h2>{oneTitle}</h2>
                        <h3>{oneValue || 0}<span>{oneUnit}</span></h3>
                    </div>
                    {
                        therrTitle && <div>
                            <h2>{therrTitle}</h2>
                            <h3>{therrValue || 0}<span>{therrUnit}</span></h3>
                        </div>
                    }
                </div>
                <div className={'buttons'}>
                    {children}
                </div>
            </div>

        </CardStyle>

    );
}

const Buttons = styled.div`
display: flex;
  justify-content: space-around;
`

const CardStyle = styled(Grid)`
  > div {
    height: 300px;
    background-color: #F7F7FB;
    border-radius: 15px;
    padding: 8px;
    box-shadow: 0px 12px 31px 3px rgba(0, 0, 0, 0.1);

    .padding {
      padding-left: 55px;
    }

    .title {
      display: flex;
      padding-top: 10px;
      padding-bottom: 10px;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        display: flex;
        border-radius: 5px;
        margin-right: 20px;
      }

      span {
        font-size: 16px;
        font-weight: bold;
        color: #222222;
      }

      border-bottom: 1px solid #E9E9E9;
    }

    .body {
      > div {
        padding-top: 20px;

        h2 {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 29px;
        }

        h3 {
          margin-top: 10px;
          line-height: 1;
          font-size: 18px;
          color: #270D4F;
          display: flex;
          align-items: baseline;

          span {
            font-size: 14px;
            color: #5D376B;
            line-height: 22px;
            display: block;
            margin-left: 10px;
          }
        }
      }

    }

    .buttons {
      display: flex;
      justify-content: space-around;
      margin-top: 30px;
      padding: 0 2%;

      box-sizing: border-box;

      p {
        font-size: 12px;
      }
    }
  }

`



